import { createSlice } from "@reduxjs/toolkit";

import {
  getPreferredUsersAsync,
  updatePreferredAsync,
} from "../actions/preferredTerms/PreferredTerms";
import { ReducerState } from "./staff";

type Terms = {
  serviceUser: string;
  staff: string;
  care: string;
};

export interface Plan {
  allowedPages: string[];
  active: boolean;
  _id: string;
  name: string;
  amount: number;
  interval: string;
  intervalCount: number;
  staffLimit: number;
  serviceUserLimit: number;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface CurrentSub {
  active: boolean;
  _id: string;
  user: string;
  plan: Plan;
  datePurchased: Date;
  expiryDate: Date;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}
export interface TenantSubscription {
  companyName: string;
  currentSub: CurrentSub;
  _id: string;
}

interface PreferredReducerState {
  terms: ReducerState<Terms>;
  tenantSubscription: TenantSubscription | null;
  tenantSubscriptionLoaded: boolean;
}

const initialState: PreferredReducerState = {
  // Set initial state here
  terms: {
    data: {
      serviceUser: "",
      staff: "",
      care: "",
    },
    loading: false,
    error: null,
  },
  tenantSubscription: null,
  tenantSubscriptionLoaded: false,
};
export const preferredTermsReducer = createSlice({
  name: "preferredTermsReducer",
  initialState,
  reducers: {
    preferredAction: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPreferredUsersAsync.pending, (state) => {
        state.terms.loading = true;
        state.terms.error = null;
      })
      .addCase(getPreferredUsersAsync.fulfilled, (state, action) => {
        state.terms.loading = false;
        state.terms.data = action.payload?.data;
        state.tenantSubscription = action.payload?.tenant;
        state.tenantSubscriptionLoaded = true;
      })
      .addCase(getPreferredUsersAsync.rejected, (state, action) => {
        state.terms.loading = false;
        state.tenantSubscriptionLoaded = true;
        state.terms.error = action.error.message || "Failed to fetch data";
      })
      .addCase(updatePreferredAsync.pending, (state) => {
        state.terms.loading = true;
        state.terms.error = null;
      })
      .addCase(updatePreferredAsync.fulfilled, (state, action) => {
        state.terms.loading = false;
        state.terms.data = action.payload;
      })
      .addCase(updatePreferredAsync.rejected, (state, action) => {
        state.terms.loading = false;
        state.terms.error = action.error.message || "Failed to fetch data";
      });
  },
});
export const { preferredAction } = preferredTermsReducer.actions;
export default preferredTermsReducer.reducer;
